import { nextIterationAsync } from "./_nextIterationAsync.js";
export const containsAsync = async (source, value, comparer) => {
    const values = nextIterationAsync(source, (x) => comparer(value, x));
    switch (values.type) {
        case 1: {
            const data = await Promise.all(values.generator());
            return data.some((x) => x);
        }
        case 2: {
            const data = await Promise.all(await values.generator());
            return data.some((x) => x);
        }
    }
};
